module.exports = __webpack_public_path__ + "fonts/Roboto-Regular-webfont.3e5675c8.woff";